import { useFormikContext } from 'formik'
import { WorkspaceSaveToInput as Input } from 'ui-components'
import { useAuthWorkspaces } from 'user-auth'
import { Values } from '../Form/types'

const WorkspaceSaveToInput = () => {
  const workspaces = useAuthWorkspaces()

  const form = useFormikContext<Values>()

  return (
    <Input
      // Hide the input if there is only one workspace or none
      hidden={workspaces.length <= 1}
      // We disable the input when there is only one item or no item
      // and when it is submitting
      disabled={workspaces.length <= 1 || form.isSubmitting}
      value={form.values.workspace}
      options={workspaces as any}
      onChange={(event, value) => {
        form.setFieldValue('workspace', value)
      }}
    />
  )
}

export { WorkspaceSaveToInput }
